import React, { useState } from 'react';

function Hero() {
  const [showAd, setShowAd] = useState(false);
  const [showBrochure, setShowBrochure] = useState(false);

  return (
    <section className="hero" id="home">
      <img src="/college-photo.jpeg" alt="Jaat College of Education Campus" className="hero-bg" />
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <h1>Welcome to Jaat College of Education</h1>
        <p>Empowering Future Educators Since 2007 — Affiliated to Kurukshetra University, Approved by NCTE</p>
        <div className="hero-buttons">
          <a href="#about" className="hero-btn">Explore More</a>
          <button onClick={() => setShowAd(true)} className="hero-btn hero-btn-outline">Advertisement</button>
          {/* <button onClick={() => setShowBrochure(true)} className="hero-btn hero-btn-outline">Advertisement</button> */}
        </div>
      </div>

      {/* Advertisement Popup */}
       {showAd && (
        <div className="popup-overlay" onClick={() => setShowAd(false)}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <button className="popup-close" onClick={() => setShowAd(false)}>&times;</button>
            <img src="/Recruitment_Advertisement.png" alt="Recruitment Advertisement" className="popup-image" />
          </div>
        </div>
      )}

      {/* Brochure Popup */}
      {showBrochure && (
        <div className="popup-overlay" onClick={() => setShowBrochure(false)}>
          <div className="popup-content popup-pdf" onClick={(e) => e.stopPropagation()}>
            <button className="popup-close" onClick={() => setShowBrochure(false)}>&times;</button>
            <iframe src="/college-brochure.pdf" title="College Brochure" className="popup-pdf-frame"></iframe>
          </div>
        </div>
      )}
    </section>
  );
}

export default Hero;
